export default {
  fetchingKeywords: state => state.fetchingKeywords,
  fetchingKeywordResults: state => state.fetchingKeywordResults,
  fetchingAdditionalResults: state => state.fetchingAdditionalResults,
  selectedKeyword: state => state.selectedKeyword,
  keywords: state => state.keywords,
  results: state => state.results,
  additionalResultErrors: state => state.additionalResultErrors,
}